import React from 'react';
import { FormSpy } from 'react-final-form';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { Form as CommonForm } from 'js/components/common/Form/Form';
import { ChangeFormField } from 'js/components/common/ChangeForm/components/ChangeFormField';

import {
    FORM_FIELD_PIN,
    FORM_FIELD_TYPE,
    FORM_FIELD_AMOUNT,
    FORM_SUBMIT_BUTTON,
    FORM_VALIDATION_CONFIG
} from './constants';

import style from './Form.scss';

export const Form = ({ onSubmit, initialValues }) => {
    return <CommonForm
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationConfig={FORM_VALIDATION_CONFIG}
        fieldsToReplaceComma={[FORM_FIELD_AMOUNT.name]}
        render={({ handleSubmit }) => (
            <form
                className={style.form}
                onSubmit={handleSubmit}
            >
                <FormSpy
                    subscription={{ submitError: true }}
                    render={({ submitError }) => submitError ?
                        <ErrorMessage error={submitError} animate={true} />
                        : null
                    }>
                </FormSpy>
                <ChangeFormField field={FORM_FIELD_TYPE} />
                <ChangeFormField field={FORM_FIELD_AMOUNT} />
                <ChangeFormField field={FORM_FIELD_PIN} />
                <ChangeFormField field={FORM_SUBMIT_BUTTON} className={style.submit} />
            </form>
        )}
    />;
};
